import WindowTitle from './WindowTitle';

export default WindowTitle;
